/*
Toggle class on another element.

HTML Usage:
<toggle-element-class data-options='{}'>
  Toggle element class button
</toggle-element-class>
*/

if (!customElements.get("lookbook-item")) {
  class Lookbook extends HTMLElement {
    constructor() {
      super();

      // Options
      this.options = {
        toggleClass: "toggle--is-active",
        target: "body",
      };

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }
      this.target = document.querySelector(this.options.target);

      this.addEventListener("click", (e) => {
        if (e.target === this.target) {
          this.close();
        } else {
          this.open();
        }
      });

      this.target.addEventListener("click", (e) => {
        if (e.target === this.target) {
          this.close();
        }
      });

      this.target
        .querySelector(".lookbook-popup__close")
        .addEventListener("click", () => {
          this.close();
        });
    }

    open() {
      this.target.style.display = "flex";
      this.animationQueue = setTimeout(() => {
        this.target.style.opacity = 1;
        this.target.querySelector(".lookbook-popup__container").style.right =
          "0";
        document.body.style.overflow = "hidden";
      }, 100);
    }
    close() {
      this.target.style.opacity = 0;
      this.target.querySelector(".lookbook-popup__container").style.right =
        "-100%";
      document.body.style.overflow = "auto";
      this.animationQueue = setTimeout(() => {
        this.target.style.display = "none";
      }, 300);
    }
  }

  customElements.define("lookbook-item", Lookbook);
}
